var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginLeftBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 647,
    height: 789,
    viewBox: "0 0 647 789",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.385498,
    width: 646,
    height: 788,
    fill: "#2D2FA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234.16 310.528L166.59 242.957L486.547 0.999775L554.117 0.570565L234.16 310.528Z",
    fill: "url(#paint0_linear_0_1)",
    fillOpacity: 0.14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M178.001 299.716L193.276 205.386L645.465 282.333L646.19 376.664L178.001 299.716Z",
    fill: "url(#paint1_linear_0_1)",
    fillOpacity: 0.14
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2031 688.801L0.000192074 625.069L292.81 253.244L364.013 316.976L31.2031 688.801Z",
    fill: "url(#paint2_linear_0_1)",
    fillOpacity: 0.14
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 520.332,
    y1: -43.2147,
    x2: 169.828,
    y2: 298.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2FA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 660.828,
    y1: 329.499,
    x2: 147.686,
    y2: 239.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2FA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 328.412,
    y1: 285.11,
    x2: -37.1867,
    y2: 682.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2FA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLeftBg);
export default __webpack_public_path__ + "static/media/login-left-bg.66fe77f89f374679850d7628990c191d.svg";
export { ForwardRef as ReactComponent };